// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2-ZfK","disabled":"FileBtn_disabled__Rx7CM","warn":"FileBtn_warn__1BzuB","fade":"FileBtn_fade__YuFXU"};